<template>
    <nav v-if="items.length" class="site-breadcrumb" aria-label="当前位置">
        <router-link to="/">首页</router-link>
        <template v-for="(item,index) in items">
            <i :key="'sep-'+index">›</i>
            <router-link v-if="item.url && index<items.length-1" :key="'link-'+index" :to="item.url">{{item.name}}</router-link>
            <span v-else :key="'text-'+index">{{item.name}}</span>
        </template>
    </nav>
</template>

<script>
export default {
    name:'SiteBreadcrumb',
    data(){ return { trail:[] } },
    computed:{ items(){ return this.trail.slice(1) } },
    created(){ this.syncTrail(this.$route) },
    watch:{ '$route.fullPath'(){ this.syncTrail(this.$route) } },
    methods:{
        pageName(route){
            const path=route.path
            if(path.indexOf('/recommend/')===0) return '推荐分析'
            if(path.indexOf('/match/')===0) return '赛事详情'
            if(path.indexOf('/member/')===0) return '专家主页'
            if(path.indexOf('/news/')===0) return '资讯详情'
            if(path==='/member') return '专家研究院'
            if(path==='/match') return '发布推荐'
            if(path==='/my') return '个人中心'
            return route.meta.title || '当前页面'
        },
        syncTrail(route){
            if(route.path==='/'){ this.trail=[{name:'首页',url:'/'}]; this.saveTrail(); return }
            let saved=[]
            try{ saved=JSON.parse(sessionStorage.getItem('football_visit_trail')||'[]') }catch(e){ saved=[] }
            if(!Array.isArray(saved) || !saved.length) saved=[{name:'首页',url:'/'}]
            const current={name:this.pageName(route),url:route.fullPath}
            const existed=saved.findIndex(item=>item.url===current.url)
            if(existed>=0) saved=saved.slice(0,existed+1)
            else saved.push(current)
            saved[0]={name:'首页',url:'/'}
            this.trail=saved.length>4?[saved[0]].concat(saved.slice(-3)):saved
            this.saveTrail()
        },
        saveTrail(){
            try{ sessionStorage.setItem('football_visit_trail',JSON.stringify(this.trail)) }catch(e){ return false }
        }
    }
}
</script>

<style scoped></style>
